import styled from 'styled-components'
import { useUser } from '../../hooks/queries/useUser'
import { useTranslation } from 'react-i18next'
import { Form } from '@galiprandi/react-tools'
import { useNavigate } from 'react-router-dom'
import { PasswordConfirmation } from '../../components/FormElements/PasswordConfirmation'
import { useState } from 'react'
import { useMigrateUser } from '../../hooks/queries/useMigrateUser'

export const MigrationStep1 = () => {
    const navigate = useNavigate()
    const { user } = useUser()
    const { t } = useTranslation('signUp')
    const { migrate, isMigrating } = useMigrateUser()

    const [changes, setChanges] = useState<Partial<FormData>>({})
    const [validPasswords, setValidPasswords] = useState(false)

    const onSubmit = async (data: FormData) => migrate(data)

    return (
        <Styles>
            {user?.requireMigration ? (
                <>
                    <h1 className="title">{t('Create password')}</h1>
                    <Form<FormData> onSubmitValues={onSubmit}>
                        <p className="center">{t('Please create a new password to continue')}</p>
                        <PasswordConfirmation
                            password=""
                            changes={changes}
                            setChanges={setChanges}
                            setValidPasswords={setValidPasswords}
                            autoFocus={false}
                        />

                        <button type="submit" className="primary" disabled={!validPasswords || isMigrating}>
                            {t('Continue')}
                        </button>
                        <button type="button" className="outlined" onClick={() => navigate('/')} style={{ margin: 0 }}>
                            {t('Cancel')}
                        </button>
                    </Form>
                </>
            ) : (
                <>
                    <h1 className="title">{t('User updated')}</h1>
                    <p className="center">{t('You have already created a password')}</p>
                    <br />
                    <button type="button" className="primary" onClick={() => navigate('/')} style={{ margin: 0 }}>
                        {t('Continue')}
                    </button>
                </>
            )}
        </Styles>
    )
}

const Styles = styled.div`
    .center {
        text-align: center;
    }

    form {
        display: flex;
        flex-direction: column;
        gap: 1em;
    }
`

// Interfaces
type FormData = {
    password: string
    confirm_password: string
}
